import BaseComponent from "../../../js/base-component";

class Footer extends BaseComponent {
  constructor(element) {
    super(element);

    const entries = this.element.querySelectorAll(".u-footer__category");

    if (entries.length) {
      entries.forEach((ele) => {
        if (!ele.classList.contains("cat-init")) {
          ele.querySelector(".u-footer__category-header").addEventListener("click", function (evt) {
            evt.preventDefault();
            toggleCategory(evt);
          });
          ele.classList.add("cat-init");
        }
      });
    }

    function toggleCategory(evt) {
      let rootEle = evt.target.closest(".u-footer__category");

      if (rootEle.classList.contains("is--active")) {
        rootEle.classList.remove("is--active");
      } else {
        rootEle.classList.add("is--active");
      }
    }
  }
}

export default {
  name: "Footer",
  definition: Footer,
};
